export default {
  firebase: {
    apiKey: "AIzaSyBvd9wVixXur0tTgJ3AiuLVGYk08QlWPLk",
    authDomain: "hack--harvest.firebaseapp.com",
    projectId: "hack--harvest",
    storageBucket: "hack--harvest.appspot.com",
    messagingSenderId: "265328840516",
    appId: "1:265328840516:web:ab501464fb9b31933a9111",
    measurementId: "G-M44BWC7C0E",
  },
  dynamicLink: {
    domain: "hackharvestapp.page.link",
    packageName: "com.hack.harvest",
    bundleId: "com.hack.harvest",
    iosUrl: "https://itunes.apple.com/us/app/hack-harvest/id12345678?mt=8",
    androidUrl:
      "https://play.google.com/store/apps/details?id=com.hack.harvest&hl=nl",
  },
  algolia: {
    appId: "GLFPPQ7P2B",
    apiKey: "3d97158a26fa952748ce2faec70a917b",
  },
};
